<template>
  <div>
    <el-table
      :data="data"
      border
      ref="multipleTable"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      v-loading="loading"
    >
      <el-table-column type="selection" width="40" align="center">
      </el-table-column>
      <el-table-column
        prop="orderId"
        label="委托单号"
        align="center"
        width="190px"
      >
      </el-table-column>
      <el-table-column
        prop="orderPrice"
        label="订单金额（元）"
        align="center"
        width="140px"
      >
      </el-table-column>
      <el-table-column
        prop="checkmallBusinessName"
        label="商家名称"
        align="center"
      >
      </el-table-column>
      <el-table-column label="下单时间" width="180px" align="center">
        <template slot-scope="{ row }">
          {{ row.createTime | timeFilter }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { parseTime } from "@/utils/index";
export default {
  filters: {
    timeFilter(val) {
      return parseTime(val);
    },
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    money: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      orderCompany: "",
      tableLoading: false,
    };
  },
  methods: {
    // 出来表格多选
    handleSelectionChange(selection) {
      let money = 0;
      selection.forEach((item) => {
        money += +item.orderPrice;
      });
      this.$emit("update:selection", selection);
      this.$emit("update:money", money);
    },
    // 表格选择
    async handleSelect(selection, row) {
      if (selection.length) {
        const { orderCompany } = row;

        if (!this.orderCompany) {
          this.orderCompany = orderCompany;
        }
        if (this.orderCompany !== orderCompany) {
          this.$refs.multipleTable.toggleRowSelection(row, false);
          selection = selection.filter(
            (v) => row.checkmallOrderMainId !== v.checkmallOrderMainId
          );
          await this.$alert("请选择相同商家的订单？", "提示", {
            confirmButtonText: "确定",
            type: "warning",
          });
        }
      } else {
        this.orderCompany = "";
      }
      this.handleSelectionChange(selection);
    },
    // 全选
    async handleAllSelect(selection) {
      console.log(33, selection);
      const sel = selection.every(
        (v) =>
          selection.filter((val) => val.orderCompany === v.orderCompany)
            .length > 1
      );
      if (!sel) {
        this.$refs.multipleTable.clearSelection();
        selection = [];
        await this.$alert("请选择相同委托单位？", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
      }
      this.handleSelectionChange(selection);
    },
  },
};
</script>
